import { render, staticRenderFns } from "./ShopAttention.vue?vue&type=template&id=10b62eb8&scoped=true"
import script from "./ShopAttention.vue?vue&type=script&lang=js"
export * from "./ShopAttention.vue?vue&type=script&lang=js"
import style0 from "./ShopAttention.vue?vue&type=style&index=0&id=10b62eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b62eb8",
  null
  
)

export default component.exports